// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 97) return "static/js/Footer.d74135b0ec6c26504a81.chunk.js";
	if (chunkId === 562) return "static/js/SearchHeader.2397a906e6532b4b16f8.chunk.js";
	if (chunkId === 665) return "static/js/SearchHistory.cc0c4e2cfb6de173b153.chunk.js";
	if (chunkId === 98) return "static/js/ErrorPage.aa8d9e6e3cd91cf11c00.chunk.js";
	if (chunkId === 620) return "static/js/GameModal.484f19fc459379342fe6.chunk.js";
	if (chunkId === 956) return "static/js/Copy.be25345b80669d639aa4.chunk.js";
	if (chunkId === 408) return "static/js/ErrorContainer.04e11e6055e8a0381d46.chunk.js";
	if (chunkId === 7) return "static/js/CookieBanner.5a8321a23c162c3edb89.chunk.js";
	if (chunkId === 449) return "static/js/Menu.385e8afdf5ca41de2024.chunk.js";
	if (chunkId === 764) return "static/js/SearchWrapper.f3e3412460bfa4f7b63e.chunk.js";
	if (chunkId === 942) return "static/js/Download.76427c5343f279abea14.chunk.js";
	if (chunkId === 215) return "static/js/SearchSuggestions.7e7bd0a596b198ae1cf5.chunk.js";
	if (chunkId === 345) return "static/js/DynamicRouteAction.a1c7906d6908ebac7e5c.chunk.js";
	if (chunkId === 788) return "static/js/logic.e4c2b7ddd53842b782b9.chunk.js";
	// return url for filenames based on template
	return undefined;
};